/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import _ from "lodash";
import { GET_REALMS, SET_SELECTED_REALM, SET_FILTERED_REALMS, GET_SELECTED_REALM_DETAILS, RESET_REALMS, GET_REALM_ENTITLEMENTS, GET_ALL_IDPS, GET_BY_IDP_STATUS } from "./types";

export interface IRealm {
  id: number;
  name: string;
};

export const getAllRealmAction = (realms, selectedRealm, pagination, noRealm) => {
  const realmList = _.remove(realms, (realm: any) => realm.status !== 'MARKED_FOR_DELETION');
  return {
    type: GET_REALMS,
    realms: realmList,
    selectedRealm,
    pagination,
    noRealm,
  };
};

export const setFilteredRealmsAction = (filteredRealms: IRealm[]) => {
  return {
    type: SET_FILTERED_REALMS,
    filteredRealms,
  };
};

export const setSelectedRealmAction = (selectedRealm: any) => {
  return {
    type: SET_SELECTED_REALM,
    selectedRealm,
  };
};

export const getSelectedRealmDetailsAction = (selectedRealmDetails: any) => {
  return {
    type: GET_SELECTED_REALM_DETAILS,
    selectedRealmDetails,
  };
}

export const getRealmEntitlementsAction = (entitlements: any) => {
  return {
    type: GET_REALM_ENTITLEMENTS,
    entitlements,
  };
};

export const resetRealmAction = () => {
  return {
    type: RESET_REALMS,
    realms: [],
    selectedRealm: {},
    noRealm: false,
  };
}
export const getAllIdpAction = (idps: any) => {
  return {
    type: GET_ALL_IDPS,
    idps,
  };
}
export const getByIdpStatusAction = (byIdpStatus: any) => {
  return {
    type: GET_BY_IDP_STATUS,
    byIdpStatus,
  };
}